export class DocumentBatch {
    public templateUuid: string;
    public documentType: number;
    public templateName: string;
    public signers: object;
    public signatureDate: Date;
    public expedient: string;
    public companyUuid: string;
    public base64: string;
    public sendEmail: boolean;
    public sendEmailCreator: boolean;
    public coordinates: object;;
}
